import * as t from 'io-ts'

export const AgeDistributionDto = t.type({
  ages7to20: t.number,
  ages21to28: t.number,
  ages29andOver: t.number
})
export type AgeDistributionDto = t.TypeOf<typeof AgeDistributionDto>

export const TransactionDto = t.type(
  {
    description: t.string,
    amountInCents: t.number
  },
  'TransactionDto'
)
export type TransactionDto = t.TypeOf<typeof TransactionDto>
